import { useQuery } from '@tanstack/react-query';

import accountsClient, { PhoneDetails } from '@clients/accountsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getPhoneDetails } = accountsClient();

const useGetCustomerContactDetails = (accountId: number) => {
    const {
        data: phoneData = [{}] as PhoneDetails[],
        error: phoneError,
        isLoading: phoneIsLoading,
        isError: phoneIsError,
        refetch,
    } = useQuery(
        ['phoneDetails', accountId],
        () => getPhoneDetails({ accountId: accountId }),
        {
            onError: notifyAPIError,
        },
    );

    return { phoneData, phoneError, phoneIsLoading, phoneIsError, refetch };
};

export default useGetCustomerContactDetails;
